// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-header[data-v-36f220da]{font-size:24px;justify-content:space-between}.el-header[data-v-36f220da],.el-header>div[data-v-36f220da]{display:flex}.menu-toggler[data-v-36f220da]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
